import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

const declineClient = async (clientId: string) => {
  const response = await authAPI.put(`/client/${clientId}/decline`)
  return response.data
}

// Note: the BE deletes the resident on decline, so the profile query is deliberately not
// invalidated - refetching it would 404 and flash the "Resident not found" state before the
// caller navigates away.
export const useDeclineClient = (clientId: string) =>
  useMutation({
    mutationFn: () => declineClient(clientId),
  })
